import { Box, Drawer, useTheme } from '@mui/material';
import { useEffect } from 'react';
import Sidebar from '../Sidebar';
import { Header } from './components';
import DrawerButton from './components/DrawerButton';
import { SidebarContainer } from './styled';
import useDrawerState from './useDrawerState';

const DRAWER_TRANSITION_DURATION = 500;

const MobileFormulaDrawer = () => {
  const theme = useTheme();

  const { isOpen, open, close } = useDrawerState();

  useEffect(() => {
    open();
  }, [open]);

  const handleStopPropagation = (event: React.TouchEvent<HTMLDivElement>) => {
    event.stopPropagation();
  };

  return (
    <Box data-testid="ai-mobile-formula-drawer">
      <DrawerButton onClick={open} />
      <Drawer
        anchor="bottom"
        open={isOpen}
        onClose={close}
        transitionDuration={DRAWER_TRANSITION_DURATION}
        sx={{
          zIndex: theme.zIndex.modal,
        }}
        ModalProps={{
          keepMounted: true,
        }}
        PaperProps={{
          sx: {
            height: '100dvh',
            overflow: 'visible',
          },
        }}
      >
        <SidebarContainer onTouchStart={handleStopPropagation}>
          <Header onClick={close} />
          <Sidebar />
        </SidebarContainer>
      </Drawer>
    </Box>
  );
};

export default MobileFormulaDrawer;
